(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core"], factory);
	else if(typeof exports === 'object')
		exports["module-metro-tulip"] = factory(require("base"), require("core"));
	else
		root["module-metro-tulip"] = factory(root["base"], root["core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'module-metro-tulip';

	    var base = __webpack_require__(3);
	    var core = __webpack_require__(4);

	    var deps = [core.name];

	    module.exports = base.createModule(module.name, deps).provider(__webpack_require__(5));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @NgInject

	    exports.tulipProvider = function () {

	        // @ngInject
	        /**
	         * @param {ng.IHttpService} $http
	         */
	        this.$get = function tulipFactory($http, lpCoreUtils, lpCoreBus) {
	            var config = {
	                getTulipSessionUrl: lpCoreUtils.resolvePortalPlaceholders('$(servicesPath)/services/rest/fraud/session/identifier'),
	                toggleTulip: '/portalserver/services/rest/config'
	            };

	            function tulip(pageId) {
	                if (window.tmx_profiling_started) {
	                    document.getElementById('tulipstag').remove();
	                    window.tmx_profiling_started = false;
	                }
	                getConfigData().then(function (response) {
	                    if (response && response.data && response.data.fraudServerUrl && response.data.fraudOrgId) {
	                        injectScript({
	                            fraudServerUrl: response.data.fraudServerUrl,
	                            fraudOrgId: response.data.fraudOrgId,
	                            pageId: pageId
	                        });
	                    }
	                });
	            }

	            function createScript(data) {
	                // inject script tag
	                if (window.tmx_profiling_started) {
	                    document.getElementById('tulipstag').remove();
	                    window.tmx_profiling_started = false;
	                }
	                if (data.fraudServerUrl && data.fraudOrgId) {
	                    injectScript(data);
	                }
	            }

	            function injectScript(config) {

	                var scriptElem = document.createElement('script');
	                scriptElem.id = "tulipstag";
	                scriptElem.type = 'text/javascript';
	                scriptElem.src = config.fraudServerUrl + '/fp/tags.js?org_id=' + config.fraudOrgId + '&session_id=' + generateSession() + '&page_id=' + config.pageId;
	                document.head.append(scriptElem);
	            }

	            function generateSession() {
	                var dt = new Date().getTime();
	                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                    var r = (dt + Math.random() * 16) % 16 | 0;
	                    dt = Math.floor(dt / 16);
	                    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	                });
	                lpCoreBus.publish('tulip:publish-session-id', uuid);
	                return uuid;
	            }

	            function getConfigData() {
	                return $http.get(config.toggleTulip);
	            }

	            return {
	                tulip: tulip,
	                getConfigData: getConfigData,
	                createScript: createScript
	            };
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js